import React from 'react';
import { injectIntl } from 'react-intl';
import ScrollTrigger from 'react-scroll-trigger';

import * as timelineComponents from 'components/layout/client/timelineComponents';
import * as timelineIcons from 'components/layout/client/timelineComponents/icons';

class TimelineEvent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inViewport: false,
    };
  }

  hasOwnRenderer = () => {
    const componentName = this.getComponentName();
    const component = this.getComponentByName(componentName);

    return !!component;
  };

  getComponentName = (prefix = 'Timeline') => {
    const { event } = this.props;
    const componentName = (prefix + '_' + event.type.toLowerCase()).replace(/_([a-z])/g, g => {
      return g[1].toUpperCase();
    });

    return componentName;
  };

  getComponentByName = name => {
    if (timelineComponents[name] !== undefined) {
      return timelineComponents[name];
    }
  };

  getTimelineIcon = () => {
    const timelineIconComponentName = this.getComponentName('TimelineIcon');
    if (timelineIcons[timelineIconComponentName] !== undefined) {
      const RenderComponent = timelineIcons[timelineIconComponentName];
      return <RenderComponent inViewport={this.state.inViewport} />;
    }

    return <div class="timeline-point small" />;
  };

  render() {
    const {
      intl: { messages },
      event,
      date,
    } = this.props;

    let content = <div class="card-block">{messages.events[this.getComponentName()]}</div>;
    if (this.hasOwnRenderer()) {
      const RenderComponent = this.getComponentByName(this.getComponentName());
      content = <RenderComponent event={event} />;
    }

    return (
      <ScrollTrigger onEnter={() => this.setState({ inViewport: true })} className="timeline-block">
        {this.getTimelineIcon()}

        <div class={'timeline-content ' + (this.state.inViewport ? 'bounce-in ' : 'is-hidden ')}>
          <div class="card share full-width">{content}</div>
          <div class="event-date">
            <small class="fs-12 hint-text">{date}</small>
          </div>
        </div>
      </ScrollTrigger>
    );
  }
}

export default injectIntl(TimelineEvent);
